export const directDebitForm = [
	{ key: 'accountName', icon: 'faAddressCard', mandatory: true, placeholder: 'Account Name', label: 'Account Name', infoContent: 'Account Name' },
	{ key: 'bsbNumber', icon: 'faBuildingColumns', mandatory: true, placeholder: 'BSB Number', label: 'BSB Number', infoContent: 'BSB Number' },
	{ key: 'accountNumber', icon: 'faCreditCard', mandatory: true, placeholder: 'Account Number', label: 'Account Number', infoContent: 'Account Number' }
];

export const arrangementFrequency = [
	{ key: 'WEEKLY', type: 'days', number: 7 },
	{ key: 'FORTNIGHTLY', type: 'days', number: 14 },
	{ key: 'MONTHLY', type: 'months', number: 1 },
	{ key: 'ANNUALLY', type: 'months', number: 12 },
	{ key: 'BI_ANNUALLY', type: 'months', number: 6 },
	{ key: 'DAILY', type: 'days', number: 1 },
	{ key: 'EVERY_SECOND_MONTH', type: 'months', number: 2 },
	{ key: 'QUARTERLY', type: 'months', number: 3 }
];

export const remainderAmountOptions = [
	{ key: 'start_of_payment', value: 'Start of Payment Plan' },
	{ key: 'end_of_payment', value: 'End of Payment Plan' }
];

export const paymentPlanValidations = [{ key: 'pp_frequency' }, { key: 'pp_fromDate' }, { key: 'pp_paymtAmt' }, { key: 'pp_remainderAmtType' }];

export const paymentOptions = {
	c_bankDetails: 'Direct Debit',
	c_razorpayCreds: 'Razorpay',
	c_paytmCreds: 'Paytm'
};

export const customerQuestionsOptions = [
	{ key: 'QNA01', value: 'In which city you were born?' },
	{ key: 'QNA02', value: 'What is your favourite colour?', },
	{ key: 'QNA03', value: 'Who is your favorite sports player?', },
	{ key: 'QNA04', value: 'What was the name of your elementary school?' },
	{ key: 'QNA05', value: 'What is the name of your favorite pet?' },
	{ key: 'QNA06', value: "What is your closest sibling's name?" },
	{ key: 'QNA07', value: 'What is your favorite movie?' },
	{ key: 'QNA08', value: 'What was the title of the first book you read?' },
	{ key: 'QNA09', value: 'What was the first concert you attended?' },
	{ key: 'QNA10', value: 'In what city did your parents meet?' }
]

export const langOptions = [
	{
		key: 'ENGLISH',
		value: 'English',
		content: {
			// Home
			'HI': 'Hi',
			'OUTSTANDING': ', you have an outstanding payment of',
			'PAY_NOW': 'Pay Now',
			'PAYMENT_PLAN': 'Create Payment Plan',
			'HARDSHIP': 'Request for Hardship',
			'CALLBACK_LATER': 'Request for Callback',
			'IMPORTANT_DOCUMENT': 'Important Documents',
			'DOWNLOAD_DOCUMENT': 'Please download your support document so that you can understand the balance outstanding',
			'DOWNLOAD': 'Download',
			'PENDING_PAYMENT': 'Payment is in progress',
			'SUCCESS_PAYMENT': 'Payment Successful',
			'VIEW_HARDSHIP': 'View Hardship',
			'VIEW_CALLBACK_LATER': 'View Callback',
			'VIEW_PAYMENT_PLAN': 'View Payment Plan',
			//Paynow
			'AMOUNT_WISH_TO_PAY': 'Amount you wish to pay',
			'INFO_AMOUNT_WISH_TO_PAY': 'Enter Amount you wish to pay',
			'DIRECT_DEBIT': 'Direct Debit',
			'DETAILS_NOMINATED_AC': 'Details of the Nominated Account to be debited',
			'AGREE': 'AGREE',
			'DOES_PAYTO': 'Does your bank support PayTo',
			// Payment Plan
			'PAYMENT_START': 'Payment Start Date',
			'PAYMENT_FREQUENCY': 'Payment Frequency',
			'INSTALLATION_AMOUNT': 'Installment Amount',
			'ADJUST_REMAINDER_AMOUNT': 'Adjust Remainder Amount',
			'INFO_PAYMENT_START': 'Select Payment Start Date',
			'INFO_PAYMENT_FREQUENCY': 'Select Payment Frequency',
			'INFO_INSTALLATION_AMOUNT': 'Enter Installment Amount',
			'INFO_ADJUST_REMAINDER_AMOUNT': 'Adjust Remainder Amount',
			'EX_PAYMENT_FREQUENCY': 'e.g: Weekly',
			'EX_END_PAYMENT': 'e.g: End of Payment Plan',
			'I_AGREE': 'I agree to the',
			'TERMS_CONDITIONS': 'Terms and Conditions',
			'CREATE_PAYMENT_PLAN': 'CREATE PAYMENT PLAN',
			'STARTS_ON': 'Start on',
			'INSTALLMENTS': 'Installments',
			'REASON_PAYMENT_PLAN': 'Reason for payment plan',
			'EX_REASON_PAYMENT_PLAN': 'e.g: Financial hardship',
			'EX_AMOUNT': 'e.g: 1,200',
			'ACCOUNT_NAME': 'Account Name',
			'BSB_NUMBER': 'BSB Number',
			'ACCOUNT_NUMBER': 'Account Number',
			// Hardship
			'HARDSHIP_REASON': 'Hardship Reason',
			'COMMENTS': 'Comments',
			'SELECT': 'Select',
			'EX_HARDSHIP': 'e.g: Natural disaster',
			'INFO_COMMENTS': 'Enter Comments',
			'INFO_HARDSHIP_REASON': 'Select Hardship Reason',
			'SAVE': 'SAVE',
			// Callback later
			'WHEN_GIVE_CALL': 'When should we give you a call?',
			'TIME_SLOTS': 'Select Time Slots',
			'CHOOSE_TIMESLOT': 'Choose Timeslot',
			'REASON_CALLBACK': 'Reason for callback',
			'INFO_REASON_CALLBACK': 'Enter Reason for callback',
			'EX_REASON_CALLBACK': 'e.g: Finance hardship',
			'REQUEST_CALLBACK': 'REQUEST CALLBACK',
			'RECEIVE_CALL': "You'll recieve call on",
			'TIME': 'Time',
			// dropdown
			'SEARCH': 'Search'
		}
	},
	{
		key: 'HINDI',
		value: 'हिंदी',
		content: {
			// Home
			'HI': 'नमस्ते',
			'OUTSTANDING': ', आपका बकाया भुगतान है',
			'PAY_NOW': 'भुगतान करें',
			'PAYMENT_PLAN': 'भुगतान योजना बनाएं',
			'HARDSHIP': 'कठिनाई के लिए अनुरोध',
			'CALLBACK_LATER': 'कॉल बैक अपडेट करें',
			'IMPORTANT_DOCUMENT': 'महत्वपूर्ण दस्त्तावेज',
			'DOWNLOAD_DOCUMENT': 'कृपया अपना समर्थन दस्तावेज़ डाउनलोड करें ताकि आप बकाया शेष राशि को समझ सकें',
			'DOWNLOAD': 'डाउनलोड करना',
			'PENDING_PAYMENT': 'भुगतान प्रगति पर है',
			'SUCCESS_PAYMENT': 'भुगतान सफल',
			'VIEW_HARDSHIP': 'कठिनाई देखें',
			'VIEW_CALLBACK_LATER': 'कॉलबैक देखें',
			'VIEW_PAYMENT_PLAN': 'भुगतान योजना देखें',
			//Paynow
			'AMOUNT_WISH_TO_PAY': 'वह राशि जो आप भुगतान करना चाहते हैं',
			'INFO_AMOUNT_WISH_TO_PAY': 'वह राशि दर्ज करें जिसका आप भुगतान करना चाहते हैं',
			'DIRECT_DEBIT': 'सीधे डेबिट',
			'DETAILS_NOMINATED_AC': 'डेबिट किए जाने वाले नामांकित खाते का विवरण',
			'AGREE': 'सहमत',
			'DOES_PAYTO': 'क्या आपका बैंक PayTo का समर्थन करता है?',
			// Payment Plan
			'PAYMENT_START': 'भुगतान आरंभ तिथि',
			'PAYMENT_FREQUENCY': 'भुगतान आवृत्ति',
			'INSTALLATION_AMOUNT': 'किस्त की राशि',
			'ADJUST_REMAINDER_AMOUNT': 'शेष राशि समायोजित करें',
			'INFO_PAYMENT_START': 'भुगतान आरंभ तिथि चुनें',
			'INFO_PAYMENT_FREQUENCY': 'भुगतान आवृत्ति का चयन करें',
			'INFO_INSTALLATION_AMOUNT': 'किस्त राशि दर्ज करें',
			'INFO_ADJUST_REMAINDER_AMOUNT': 'शेष राशि समायोजित करें का चयन करें',
			'I_AGREE': 'मैं करने के लिए सहमत हूं',
			'TERMS_CONDITIONS': 'नियम और शर्तें',
			'CREATE_PAYMENT_PLAN': 'भुगतान योजना बनाएं',
			'EX_PAYMENT_FREQUENCY': 'उदाहरण: साप्ताहिक',
			'EX_END_PAYMENT': 'उदाहरण: भुगतान योजना की समाप्ति',
			'START_OF_PAYMENT': 'भुगतान योजना की शुरुआत',
			'END_OF_PAYMENT': 'भुगतान योजना की समाप्ति',
			'STARTS_ON': 'शुरुआत करना',
			'INSTALLMENTS': 'किश्तों',
			'REASON_PAYMENT_PLAN': 'भुगतान योजना का कारण',
			'EX_REASON_PAYMENT_PLAN': 'उदाहरणार्थ: वित्तीय कठिनाई',
			'YEARLY': 'वार्षिक',
			'BI_ANNUALLY': 'द्विवार्षिक',
			'MONTHLY': 'महीने के',
			'QUARTERLY': 'त्रैमासिक',
			'EVERY_SECOND_MONTH': 'हर दूसरे महीने',
			'FORTNIGHTLY': 'पाक्षिक',
			'WEEKLY': 'साप्ताहिक',
			'DAILY': 'दैनिक',
			'EX_AMOUNT': 'उदाहरण: 1,200',
			'ACCOUNT_NAME': 'खाता नाम',
			'BSB_NUMBER': 'बीएसबी नंबर',
			'ACCOUNT_NUMBER': 'खाता संख्या',
			// Hardship
			'HARDSHIP_REASON': 'कठिनाई का कारण',
			'COMMENTS': 'टिप्पणियाँ',
			'SELECT': 'चुनना',
			'EX_HARDSHIP': 'उदाहरण: प्राकृतिक आपदा',
			'INFO_COMMENTS': 'टिप्पणियाँ दर्ज करें',
			'INFO_HARDSHIP_REASON': 'कठिनाई का कारण चुनें',
			'SAVE': 'बचाना',
			'DONT_REPORT': 'रिपोर्ट न करें',
			'TEMPORARY': 'अस्थायी',
			'CONTRACT_VARIATION': 'अनुबंध भिन्नता',
			'DECEASED': 'मृतक',
			'DISASTER': 'आपदा',
			'ILLNESS': 'बीमारी',
			'JAIL': 'जेल',
			'MATERNITY_LEAVE': 'प्रसूति अवकाश',
			'OVER_COMMITMENT': 'अति प्रतिबद्धता',
			'DISABILITY': 'विकलांगता',
			'PROPERTY_ON_THE_MARKET': 'बाज़ार में संपत्ति',
			'REDUCED_INCOME': 'आय में कमी',
			'SEPERATION': 'जुदाई',
			'INDUSTRIAL_ACTION': 'औद्योगिक कार्यकलाप',
			'UNEMPLOYED': 'बेरोजगार',
			'REDUNDANCY': 'फालतूपन',
			'OTHER': 'अन्य',
			// Callback later
			'WHEN_GIVE_CALL': 'हमें आपको कब कॉल करना चाहिए?',
			'TIME_SLOTS': 'टाइम स्लॉट चुनें',
			'CHOOSE_TIMESLOT': 'टाइमस्लॉट चुनें',
			'REASON_CALLBACK': 'कॉलबैक का कारण',
			'INFO_REASON_CALLBACK': 'कॉलबैक का कारण दर्ज करें',
			'EX_REASON_CALLBACK': 'उदाहरणार्थ: वित्त संबंधी कठिनाई',
			'REQUEST_CALLBACK': 'कॉलबैक का अनुरोध करें',
			'RECEIVE_CALL': 'आपको कॉल प्राप्त होगी',
			'TIME': 'समय',
			// dropdown
			'SEARCH': 'खोज'

		}
	},
	{
		key: 'TAMIL',
		value: 'தமிழ்',
		content: {
			// Home
			'HI': 'வணக்கம்',
			'OUTSTANDING': ', உங்களிடம் நிலுவைத் தொகை உள்ளது',
			'PAY_NOW': 'இப்போது செலுத்த',
			'PAYMENT_PLAN': 'பணம் செலுத்தும் திட்டம்',
			'HARDSHIP': 'சிரமத்திற்கு வேண்டுகோள்',
			'CALLBACK_LATER': 'திரும்ப அழைக்கவும்',
			'IMPORTANT_DOCUMENT': 'முக்கியமான ஆவணங்கள்',
			'DOWNLOAD_DOCUMENT': 'நிலுவைத் தொகையை நீங்கள் புரிந்து கொள்ள உங்கள் ஆதரவு ஆவணத்தைப் பதிவிறக்கவும்',
			'DOWNLOAD': 'பதிவிறக்க',
			'PENDING_PAYMENT': 'பணம் செலுத்துதல் நடந்து கொண்டிருக்கிறது',
			'SUCCESS_PAYMENT': 'பணம் செலுத்துதல் வெற்றிகரமாக உள்ளது',
			'VIEW_HARDSHIP': 'கஷ்டத்தைப் பார்க்கவும்',
			'VIEW_CALLBACK_LATER': 'திரும்ப திரும்பப் பார்க்கவும்',
			'VIEW_PAYMENT_PLAN': 'கட்டணத் திட்டத்தைப் பார்க்கவும்',
			//Paynow
			'AMOUNT_WISH_TO_PAY': 'நீங்கள் செலுத்த விரும்பும் தொகை',
			'INFO_AMOUNT_WISH_TO_PAY': 'நீங்கள் செலுத்த விரும்பும் தொகையை உள்ளிடவும்',
			'DIRECT_DEBIT': 'நேரடி பற்று',
			'DETAILS_NOMINATED_AC': 'டெபிட் செய்யப்படும் பரிந்துரைக்கப்பட்ட கணக்கின் விவரங்கள்',
			'AGREE': 'ஒப்புக்கொள்',
			'DOES_PAYTO': 'உங்கள் வங்கி PayToவை ஆதரிக்கிறதா',
			// Payment Plan
			'PAYMENT_START': 'கட்டணம் செலுத்தும் தொடக்க தேதி',
			'PAYMENT_FREQUENCY': 'கட்டண அதிர்வெண்',
			'INSTALLATION_AMOUNT': 'தவணை தொகை',
			'ADJUST_REMAINDER_AMOUNT': 'மீதமுள்ள தொகையை சரிசெய்யவும்',
			'INFO_PAYMENT_START': 'கட்டணம் செலுத்தும் தொடக்க தேதி',
			'INFO_PAYMENT_FREQUENCY': 'கட்டண அதிர்வெண்ணைத் தேர்ந்தெடுக்கவும்',
			'INFO_INSTALLATION_AMOUNT': 'தவணை தொகை',
			'INFO_ADJUST_REMAINDER_AMOUNT': 'மீதமுள்ள தொகையை சரிசெய்யவும்',
			'EX_PAYMENT_FREQUENCY': 'எ.கா: வாராந்திர',
			'EX_END_PAYMENT': 'எ.கா: கட்டணத் திட்டத்தின் முடிவு',
			'I_AGREE': 'நான் இதனை ஏற்று கொள்கிறேன்',
			'TERMS_CONDITIONS': 'விதிமுறைகள் மற்றும் நிபந்தனைகள்',
			'CREATE_PAYMENT_PLAN': 'கட்டணத் திட்டத்தை உருவாக்கவும்',
			'STARTS_ON': 'தொடங்கவும்',
			'INSTALLMENTS': 'தவணைகள்',
			'REASON_PAYMENT_PLAN': 'கட்டணத் திட்டத்திற்கான காரணம்',
			'EX_REASON_PAYMENT_PLAN': 'எ.கா: நிதிக் கஷ்டம்',
			'YEARLY': 'ஆண்டு',
			'BI_ANNUALLY': 'அரை ஆண்டுதோறும்',
			'MONTHLY': 'மாதாந்திர',
			'QUARTERLY': 'காலாண்டு',
			'EVERY_SECOND_MONTH': 'ஒவ்வொரு இரண்டாவது மாதமும்',
			'FORTNIGHTLY': 'இரண்டு இரவு',
			'WEEKLY': 'வாரந்தோறும்',
			'DAILY': 'தினசரி',
			'START_OF_PAYMENT': 'கட்டணம் செலுத்துவதற்கான ஆரம்பம்',
			'END_OF_PAYMENT': 'பணம் செலுத்தும் முடிவு',
			'EX_AMOUNT': 'எ.கா: 1,200',
			'ACCOUNT_NAME': 'கணக்கின் பெயர்',
			'BSB_NUMBER': 'பிஎஸ்பி எண்',
			'ACCOUNT_NUMBER': 'கணக்கு எண்',
			// Hardship
			'HARDSHIP_REASON': 'கஷ்டம் காரணம்',
			'COMMENTS': 'கருத்துகள்',
			'SELECT': 'தேர்ந்தெடு',
			'EX_HARDSHIP': 'எ.கா: இயற்கை பேரழிவு',
			'INFO_COMMENTS': 'கருத்துகளை உள்ளிடவும்',
			'INFO_HARDSHIP_REASON': 'கடினமான காரணத்தைத் தேர்ந்தெடுக்கவும்',
			'SAVE': 'சேமிக்கவும்',
			'DONT_REPORT': 'புகாரளிக்க வேண்டாம்',
			'TEMPORARY': 'தற்காலிக',
			'CONTRACT_VARIATION': 'ஒப்பந்த மாறுபாடு',
			'DECEASED': 'மறைந்தார்',
			'DISASTER': 'பேரழிவு',
			'ILLNESS': 'உடல் நலமின்மை',
			'JAIL': 'சிறை',
			'MATERNITY_LEAVE': 'மகப்பேறு விடுப்பு',
			'OVER_COMMITMENT': 'ஓவர் கமிட்மெண்ட்',
			'DISABILITY': 'இயலாமை',
			'PROPERTY_ON_THE_MARKET': 'சந்தையில் உள்ள சொத்து',
			'REDUCED_INCOME': 'குறைக்கப்பட்ட வருமானம்',
			'SEPERATION': 'பிரித்தல்',
			'INDUSTRIAL_ACTION': 'தொழில்துறை நடவடிக்கை',
			'UNEMPLOYED': 'வேலையில்லாதவர்',
			'REDUNDANCY': 'பணிநீக்கம்',
			'OTHER': 'மற்றவை',
			// Callback later
			'WHEN_GIVE_CALL': 'நாங்கள் உங்களுக்கு எப்போது அழைப்பு கொடுக்க வேண்டும்?',
			'TIME_SLOTS': 'நேர இடங்களைத் தேர்ந்தெடுக்கவும்',
			'CHOOSE_TIMESLOT': 'டைம்ஸ்லாட்டைத் தேர்ந்தெடுக்கவும்',
			'REASON_CALLBACK': 'திரும்ப அழைப்பதற்கான காரணம்',
			'INFO_REASON_CALLBACK': 'திரும்ப அழைப்பதற்கான காரணத்தை உள்ளிடவும்',
			'EX_REASON_CALLBACK': 'எ.கா: நிதி நெருக்கடி',
			'REQUEST_CALLBACK': 'திரும்ப அழைக்கவும்',
			'RECEIVE_CALL': "நீங்கள் அழைப்பைப் பெறுவீர்கள்",
			'TIME': 'நேரம்',
			// dropdown
			'SEARCH': 'தேடல்'
		}
	},
	{
		key: 'TELUGU',
		value: 'తెలుగు',
		content: {
			// Home
			'HI': 'హాయ్',
			'OUTSTANDING': ', మీకు బకాయి చెల్లింపు ఉంది',
			'PAY_NOW': 'ఇప్పుడు చెల్లించండి',
			'PAYMENT_PLAN': 'చెల్లింపు ప్రణాళికను సృష్టించండి',
			'HARDSHIP': 'కష్టాల కోసం అభ్యర్థన',
			'CALLBACK_LATER': 'కాల్ బ్యాక్ కోసం అభ్యర్థన',
			'IMPORTANT_DOCUMENT': 'ముఖ్యమైన పత్రాలు',
			'DOWNLOAD_DOCUMENT': 'దయచేసి మీ మద్దతు పత్రాన్ని డౌన్‌లోడ్ చేసుకోండి, తద్వారా మీరు బ్యాలెన్స్ బాకీని అర్థం చేసుకోగలరు',
			'DOWNLOAD': 'డౌన్‌లోడ్ చేయండి',
			'PENDING_PAYMENT': 'చెల్లింపు పురోగతిలో ఉంది',
			'SUCCESS_PAYMENT': 'చెల్లింపు విజయవంతమైంది',
			'VIEW_HARDSHIP': 'కష్టాలను చూడండి',
			'VIEW_CALLBACK_LATER': 'తిరిగి కాల్ చేయడాన్ని వీక్షించండి',
			'VIEW_PAYMENT_PLAN': 'చెల్లింపు ప్రణాళికను వీక్షించండి',
			//Paynow
			'AMOUNT_WISH_TO_PAY': 'మీరు చెల్లించాలనుకుంటున్న మొత్తం',
			'INFO_AMOUNT_WISH_TO_PAY': 'మీరు చెల్లించాలనుకుంటున్న మొత్తాన్ని నమోదు చేయండి',
			'DIRECT_DEBIT': 'నేరుగా జమ',
			'DETAILS_NOMINATED_AC': 'నామినేట్ చేయబడిన ఖాతా వివరాలు డెబిట్ చేయబడతాయి',
			'AGREE': 'అంగీకరిస్తున్నారు',
			'DOES_PAYTO': 'మీ బ్యాంక్ PayToకి మద్దతు ఇస్తుందా',
			// Payment Plan
			'PAYMENT_START': 'చెల్లింపు ప్రారంభ తేదీ',
			'PAYMENT_FREQUENCY': 'చెల్లింపు ఫ్రీక్వెన్సీ',
			'INSTALLATION_AMOUNT': 'వాయిదా మొత్తం',
			'ADJUST_REMAINDER_AMOUNT': 'మిగిలిన మొత్తాన్ని సర్దుబాటు చేయండి',
			'INFO_PAYMENT_START': 'చెల్లింపు ప్రారంభ తేదీని ఎంచుకోండి',
			'INFO_PAYMENT_FREQUENCY': 'చెల్లింపు ఫ్రీక్వెన్సీని ఎంచుకోండి',
			'INFO_INSTALLATION_AMOUNT': 'వాయిదా మొత్తాన్ని నమోదు చేయండి',
			'INFO_ADJUST_REMAINDER_AMOUNT': 'మిగిలిన మొత్తాన్ని సర్దుబాటు చేయండి',
			'EX_PAYMENT_FREQUENCY': 'ఉదా: ప్రతివారం',
			'EX_END_PAYMENT': 'ఉదా: చెల్లింపు ప్రణాళిక ముగింపు',
			'I_AGREE': 'నేను అంగీకరిస్తున్నాను',
			'TERMS_CONDITIONS': 'నిబంధనలు మరియు షరతులు',
			'CREATE_PAYMENT_PLAN': 'చెల్లింపు ప్రణాళికను సృష్టించండి',
			'STARTS_ON': 'ప్రారంభించండి',
			'INSTALLMENTS': 'వాయిదాలు',
			'REASON_PAYMENT_PLAN': 'చెల్లింపు ప్రణాళికకు కారణం',
			'EX_REASON_PAYMENT_PLAN': 'ఉదా: ఆర్థిక కష్టాలు',
			'YEARLY': 'ప్రతి సంవత్సరం',
			'BI_ANNUALLY': 'అర్థ సంవత్సరము',
			'MONTHLY': 'నెలవారీ',
			'QUARTERLY': 'క్వార్టర్లీ',
			'EVERY_SECOND_MONTH': 'ప్రతి రెండవ నెల',
			'FORTNIGHTLY': 'ఫోర్త్నైట్లీ',
			'WEEKLY': 'వారానికోసారి',
			'DAILY': 'రోజువారీ',
			'START_OF_PAYMENT': 'చెల్లింపు ప్రారంభం',
			'END_OF_PAYMENT': 'చెల్లింపు ముగింపు',
			'EX_AMOUNT': 'ఉదా: 1,200',
			'ACCOUNT_NAME': 'ఖాతా పేరు',
			'BSB_NUMBER': 'బి.ఎస్.బి సంఖ్య',
			'ACCOUNT_NUMBER': 'ఖాతా సంఖ్య',
			// Hardship
			'HARDSHIP_REASON': 'కష్టానికి కారణం',
			'COMMENTS': 'వ్యాఖ్యలు',
			'SELECT': 'ఎంచుకోండి',
			'EX_HARDSHIP': 'ఉదా: ప్రకృతి విపత్తు',
			'INFO_COMMENTS': 'వ్యాఖ్యలను నమోదు చేయండి',
			'INFO_HARDSHIP_REASON': 'కష్టానికి కారణాన్ని ఎంచుకోండి',
			'SAVE': 'సేవ్ చేయండి',
			'DONT_REPORT': 'రిపోర్ట్ చేయవద్దు',
			'TEMPORARY': 'తాత్కాలికం',
			'CONTRACT_VARIATION': 'కాంట్రాక్ట్ వైవిధ్యం',
			'DECEASED': 'మరణించాడు',
			'DISASTER': 'విపత్తు',
			'ILLNESS': 'రోగము',
			'JAIL': 'జైలు',
			'MATERNITY_LEAVE': 'ప్రసూతి సెలవు',
			'OVER_COMMITMENT': 'ఓవర్ కమిట్‌మెంట్',
			'DISABILITY': 'వైకల్యం',
			'PROPERTY_ON_THE_MARKET': 'మార్కెట్‌లో ఆస్తి',
			'REDUCED_INCOME': 'తగ్గిన ఆదాయం',
			'SEPERATION': 'విభజన',
			'INDUSTRIAL_ACTION': 'పారిశ్రామిక చర్య',
			'UNEMPLOYED': 'నిరుద్యోగి',
			'REDUNDANCY': 'రిడండన్సీ',
			'OTHER': 'ఇతర',
			// Callback later
			'WHEN_GIVE_CALL': 'మేము మీకు ఎప్పుడు కాల్ చేయాలి?',
			'TIME_SLOTS': 'టైమ్ స్లాట్‌లను ఎంచుకోండి',
			'CHOOSE_TIMESLOT': 'టైమ్‌స్లాట్‌ని ఎంచుకోండి',
			'REASON_CALLBACK': 'తిరిగి కాల్ చేయడానికి కారణం',
			'INFO_REASON_CALLBACK': 'కాల్‌బ్యాక్ కోసం కారణాన్ని నమోదు చేయండి',
			'EX_REASON_CALLBACK': 'ఉదా: ఆర్థిక కష్టాలు',
			'REQUEST_CALLBACK': 'కాల్‌బ్యాక్‌ని అభ్యర్థించండి',
			'RECEIVE_CALL': "మీరు కాల్ స్వీకరిస్తారు",
			'TIME': 'సమయం',
			// dropdown
			'SEARCH': 'వెతకండి'
		}
	},
	{
		key: 'KANNADA',
		value: 'ಕನ್ನಡ',
		content: {
			// Home
			'HI': 'ನಮಸ್ತೆ',
			'OUTSTANDING': ', ನೀವು ಬಾಕಿ ಪಾವತಿಯನ್ನು ಹೊಂದಿದ್ದೀರಿ',
			'PAY_NOW': 'ಈಗ ಪಾವತಿಸಿ',
			'PAYMENT_PLAN': 'ಪಾವತಿ ಯೋಜನೆಯನ್ನು ರಚಿಸಿ',
			'HARDSHIP': 'ಸಂಕಷ್ಟಕ್ಕೆ ಮನವಿ',
			'CALLBACK_LATER': 'ಕಾಲ್‌ಬ್ಯಾಕ್‌ಗಾಗಿ ವಿನಂತಿ',
			'IMPORTANT_DOCUMENT': 'ಪ್ರಮುಖ ದಾಖಲೆಗಳು',
			'DOWNLOAD_DOCUMENT': 'ಬಾಕಿ ಉಳಿದಿರುವುದನ್ನು ನೀವು ಅರ್ಥಮಾಡಿಕೊಳ್ಳಲು ದಯವಿಟ್ಟು ನಿಮ್ಮ ಬೆಂಬಲ ಡಾಕ್ಯುಮೆಂಟ್ ಅನ್ನು ಡೌನ್‌ಲೋಡ್ ಮಾಡಿ',
			'DOWNLOAD': 'ಡೌನ್‌ಲೋಡ್ ಮಾಡಿ',
			'PENDING_PAYMENT': 'ಪಾವತಿ ಪ್ರಗತಿಯಲ್ಲಿದೆ',
			'SUCCESS_PAYMENT': 'ಪಾವತಿ ಯಶಸ್ವಿಯಾಗಿದೆ',
			'VIEW_HARDSHIP': 'ಕಷ್ಟವನ್ನು ವೀಕ್ಷಿಸಿ',
			'VIEW_CALLBACK_LATER': 'ಕಾಲ್ಬ್ಯಾಕ್ ವೀಕ್ಷಿಸಿ',
			'VIEW_PAYMENT_PLAN': 'ಪಾವತಿ ಯೋಜನೆಯನ್ನು ವೀಕ್ಷಿಸಿ',
			//Paynow
			'AMOUNT_WISH_TO_PAY': 'ನೀವು ಪಾವತಿಸಲು ಬಯಸುವ ಮೊತ್ತ',
			'INFO_AMOUNT_WISH_TO_PAY': 'ನೀವು ಪಾವತಿಸಲು ಬಯಸುವ ಮೊತ್ತವನ್ನು ನಮೂದಿಸಿ',
			'DIRECT_DEBIT': 'ನೇರ ಖರ್ಚು',
			'DETAILS_NOMINATED_AC': 'ಡೆಬಿಟ್ ಮಾಡಬೇಕಾದ ನಾಮನಿರ್ದೇಶಿತ ಖಾತೆಯ ವಿವರಗಳು',
			'AGREE': 'ಒಪ್ಪುತ್ತೇನೆ',
			'DOES_PAYTO': 'ನಿಮ್ಮ ಬ್ಯಾಂಕ್ PayTo ಅನ್ನು ಬೆಂಬಲಿಸುತ್ತದೆಯೇ',
			// Payment Plan
			'PAYMENT_START': 'ಪಾವತಿ ಪ್ರಾರಂಭ ದಿನಾಂಕ',
			'PAYMENT_FREQUENCY': 'ಪಾವತಿ ಆವರ್ತನ',
			'INSTALLATION_AMOUNT': 'ಕಂತು ಮೊತ್ತ',
			'ADJUST_REMAINDER_AMOUNT': 'ಉಳಿದ ಮೊತ್ತವನ್ನು ಹೊಂದಿಸಿ',
			'INFO_PAYMENT_START': 'ಪಾವತಿ ಪ್ರಾರಂಭ ದಿನಾಂಕವನ್ನು ಆಯ್ಕೆಮಾಡಿ',
			'INFO_PAYMENT_FREQUENCY': 'ಪಾವತಿ ಆವರ್ತನವನ್ನು ಆಯ್ಕೆಮಾಡಿ',
			'INFO_INSTALLATION_AMOUNT': 'ಕಂತು ಮೊತ್ತವನ್ನು ನಮೂದಿಸಿ',
			'INFO_ADJUST_REMAINDER_AMOUNT': 'ಉಳಿದ ಮೊತ್ತವನ್ನು ಹೊಂದಿಸಿ',
			'EX_PAYMENT_FREQUENCY': 'ಉದಾ: ಸಾಪ್ತಾಹಿಕ',
			'EX_END_PAYMENT': 'ಉದಾ: ಪಾವತಿ ಯೋಜನೆ ಅಂತ್ಯ',
			'I_AGREE': 'ನಾನು ಒಪ್ಪುತ್ತೇನೆ',
			'TERMS_CONDITIONS': 'ನಿಯಮಗಳು ಮತ್ತು ಷರತ್ತುಗಳು',
			'CREATE_PAYMENT_PLAN': 'ಪಾವತಿ ಯೋಜನೆಯನ್ನು ರಚಿಸಿ',
			'STARTS_ON': 'ಪ್ರಾರಂಭಿಸಿ',
			'INSTALLMENTS': 'ಕಂತುಗಳಲ್ಲಿ',
			'REASON_PAYMENT_PLAN': 'ಪಾವತಿ ಯೋಜನೆಗೆ ಕಾರಣ',
			'EX_REASON_PAYMENT_PLAN': 'ಉದಾ: ಆರ್ಥಿಕ ಸಂಕಷ್ಟ',
			'YEARLY': 'ವಾರ್ಷಿಕ',
			'BI_ANNUALLY': 'ಅರ್ಧ ವಾರ್ಷಿಕ',
			'MONTHLY': 'ಮಾಸಿಕ',
			'QUARTERLY': 'ತ್ರೈಮಾಸಿಕ',
			'EVERY_SECOND_MONTH': 'ಪ್ರತಿ ಎರಡನೇ ತಿಂಗಳು',
			'FORTNIGHTLY': 'ಫೋರ್ಟ್ನೈಟ್ಲಿ',
			'WEEKLY': 'ವಾರ',
			'DAILY': 'ಪ್ರತಿದಿನ',
			'START_OF_PAYMENT': 'ಪಾವತಿಯ ಪ್ರಾರಂಭ',
			'END_OF_PAYMENT': 'ಪಾವತಿಯ ಅಂತ್ಯ',
			'EX_AMOUNT': 'ಉದಾ: 1,200',
			'ACCOUNT_NAME': 'ಖಾತೆಯ ಹೆಸರು',
			'BSB_NUMBER': 'ಬಿ.ಎಸ್.ಬಿ ಸಂಖ್ಯೆ',
			'ACCOUNT_NUMBER': 'ಖಾತೆ ಸಂಖ್ಯೆ',
			// Hardship
			'HARDSHIP_REASON': 'ಕಷ್ಟದ ಕಾರಣ',
			'COMMENTS': 'ಕಾಮೆಂಟ್‌ಗಳು',
			'SELECT': 'ಆಯ್ಕೆ ಮಾಡಿ',
			'EX_HARDSHIP': 'ಉದಾ: ನೈಸರ್ಗಿಕ ವಿಕೋಪ',
			'INFO_COMMENTS': 'ಕಾಮೆಂಟ್‌ಗಳನ್ನು ನಮೂದಿಸಿ',
			'INFO_HARDSHIP_REASON': 'ಕಷ್ಟದ ಕಾರಣವನ್ನು ಆಯ್ಕೆಮಾಡಿ',
			'SAVE': 'ಉಳಿಸಿ',
			'DONT_REPORT': 'ವರದಿ ಮಾಡಬೇಡಿ',
			'TEMPORARY': 'ತಾತ್ಕಾಲಿಕ',
			'CONTRACT_VARIATION': 'ಒಪ್ಪಂದದ ವ್ಯತ್ಯಾಸ',
			'DECEASED': 'ನಿಧನರಾದರು',
			'DISASTER': 'ದುರಂತದ',
			'ILLNESS': 'ಅನಾರೋಗ್ಯ',
			'JAIL': 'ಜೈಲು',
			'MATERNITY_LEAVE': 'ಹೆರಿಗೆ ರಜೆ',
			'OVER_COMMITMENT': 'ಓವರ್ ಕಮಿಟ್‌ಮೆಂಟ್',
			'DISABILITY': 'ಅಂಗವಿಕಲತೆ',
			'PROPERTY_ON_THE_MARKET': 'ಮಾರುಕಟ್ಟೆಯಲ್ಲಿ ಆಸ್ತಿ',
			'REDUCED_INCOME': 'ಕಡಿಮೆಯಾದ ಆದಾಯ',
			'SEPERATION': 'ಪ್ರತ್ಯೇಕತೆ',
			'INDUSTRIAL_ACTION': 'ಕೈಗಾರಿಕಾ ಕ್ರಿಯೆ',
			'UNEMPLOYED': 'ನಿರುದ್ಯೋಗಿ',
			'REDUNDANCY': 'ಪುನರಾವರ್ತನೆ',
			'OTHER': 'ಇತರೆ',
			// Callback later
			'WHEN_GIVE_CALL': 'ನಾವು ನಿಮಗೆ ಯಾವಾಗ ಕರೆ ನೀಡಬೇಕು?',
			'TIME_SLOTS': 'ಟೈಮ್ ಸ್ಲಾಟ್‌ಗಳನ್ನು ಆಯ್ಕೆಮಾಡಿ',
			'CHOOSE_TIMESLOT': 'ಟೈಮ್ಸ್ಲಾಟ್ ಆಯ್ಕೆಮಾಡಿ',
			'REASON_CALLBACK': 'ಕಾಲ್‌ಬ್ಯಾಕ್‌ಗೆ ಕಾರಣ',
			'INFO_REASON_CALLBACK': 'ಕಾಲ್‌ಬ್ಯಾಕ್‌ಗೆ ಕಾರಣವನ್ನು ನಮೂದಿಸಿ',
			'EX_REASON_CALLBACK': 'ಉದಾ: ಹಣಕಾಸಿನ ತೊಂದರೆ',
			'REQUEST_CALLBACK': 'ಕಾಲ್‌ಬ್ಯಾಕ್‌ಗೆ ವಿನಂತಿಸಿ',
			'RECEIVE_CALL': "ನೀವು ಕರೆಯನ್ನು ಸ್ವೀಕರಿಸುತ್ತೀರಿ",
			'TIME': 'ಸಮಯ',
			// dropdown
			'SEARCH': 'ಹುಡುಕಿ'
		}
	}
]
